import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'

export const outlookIntegration: PreviewIntegration = {
  description: 'Supercharge your Go agents and chats with emails from Outlook.',
  id: 'outlook',
  name: 'Microsoft Outlook',
  icon: 'outlook-logo',
}
